'use strict';

export default class AddController {

  /*@ngInject*/
  constructor($http, $state, $timeout, $scope, Upload, toaster) {
    this.$http = $http;
    this.$state = $state;
    this.$timeout = $timeout;
    this.Upload = Upload;
    this.$scope = $scope;
    this.toaster = toaster;

    this.newDict = {};
  }

  addDict(file) {
    this.toaster.pop({
      type: 'wait',
      title: '正在上传',
      body: file.name,
      timeout: 3000 * 1000
    });
    file.upload = this.Upload.upload({
      url: '/api/1/dictionary/uploadAndSave',
      file: file,
      data: this.newDict,
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });

    file.upload.progress((evt) => {
      file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
    });

    file.upload.success((data, status, headers, config) => {
      this.toaster.clear();
      this.toaster.pop('success', '上传成功', file.name);
      this.$state.go('dictionaries.list');
    });

    file.upload.error((err) => {
      this.toaster.clear();
      this.toaster.pop('error', '上传失败', JSON.stringify(err));
    });
  }

}



// WEBPACK FOOTER //
// ./client/app/dictionaries/add/add.controller.js